export const GRID_SPLIT_EVENTS = { XXL: "1" };
export const GRID_SPLIT_ARTICLES = { XXL: "3", S: "1" };
export const GRID_SPLIT_REPORTS = { XXL: "4", S: "2", XXS: "1" };
